import { render, staticRenderFns } from "./ClarifyDetails.vue?vue&type=template&id=18a6903f&scoped=true&"
import script from "./ClarifyDetails.vue?vue&type=script&lang=js&"
export * from "./ClarifyDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClarifyDetails.vue?vue&type=style&index=0&id=18a6903f&scoped=true&lang=less&"
import style1 from "./ClarifyDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6903f",
  null
  
)

export default component.exports